module.exports = __webpack_public_path__ + "img/twilio.06d51e28.jpg";